import { NavLink } from "react-router";
import { ReactNode } from "react";

interface NavigationItemProps {
  to: string;
  children: ReactNode;
}

import navigationStyles from "./NavigationItem.module.css";

export const NavigationItem: React.FC<NavigationItemProps> = ({
  to,
  children,
}) => {
  return (
    <NavLink
      to={to}
      className={({ isActive }) =>
        isActive ? navigationStyles.activeItem : navigationStyles.inactiveItem
      }
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {children}
    </NavLink>
  );
};
